import Vue from 'vue'
import Router from 'vue-router'

import Store from './store'

import Storage from './helpers/storage'

import Auth from './modules/auth'
import Consent from './modules/consent'

import AddInbox from './views/AddInbox.vue'
import ConsentPage from './views/ConsentPage.vue'
import FetchAndEmpty from './views/FetchAndEmpty.vue'
import FetchExpress from './views/FetchExpress.vue'
import Landing from './views/Landing/Landing'
import LoginEmail from './views/LoginEmail.vue'
import LoginFlowGoogle from './views/LoginFlowGoogle.vue'
import LoginPage from './views/LoginPage.vue'
import LoginProvider from './views/LoginProvider.vue'
import MagicLinkPre from './views/MagicLinkPre.vue'
import MagicLinkPost from './views/MagicLinkPost.vue'
import LoginOAuth from './views/LoginOAuth.vue'
import LoginOAuthRedirect from './views/LoginOAuthRedirect.vue'
import MyActions from './views/MyActions.vue'
import NewslettersV2 from './views/NewslettersV2.vue'
import Partner from './views/Partner.vue'
import DirectDeleteAccount from './views/DirectDeleteAccount.vue'
import SaveThePlanet from './views/SaveThePlanet.vue'
import Settings from './views/Settings.vue'
import Stats from './views/Stats.vue'
import TikTokRedirect from './views/TikTokRedirect'
import UserForm from './views/UserForm.vue'
import WeForest from './views/WeForest.vue'

import Agreements from './modules/agreements'
import Providers from './modules/providers'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: `/${Storage.getItem('lang')}`,
    routes: [
        {
            path: '/',
            name: 'landing',
            component: Landing,
            beforeEnter: LandingRules
        },
        {
            path: '/consent-page',
            name: 'consent-page',
            component: ConsentPage
        },
        {
            path: '/login/:provider/redirect',
            component: LoginOAuthRedirect,
            beforeEnter: loginRules
        },
        {
            path: '/login-o-auth/:provider',
            component: LoginOAuth,
            beforeEnter: loginRules
        },
        {
            path: '/login',
            name: 'login',
            component: LoginPage,
            beforeEnter: loginRules
        },
        {
            path: '/login/email',
            name: 'login-email',
            component: LoginEmail
        },
        {
            path: '/login/google',
            name: 'login-google',
            component: LoginFlowGoogle,
            beforeEnter: loginRules
        },
        {
            path: '/login/google/app_pass',
            redirect: () => ({
                path: '/login/google',
                query: {step: 'app_pass'}
            })
        },
        {
            path: '/login/yahoo',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/aol',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/gmx',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/icloud',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/web',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/:provider',
            redirect: '/login'
        },
        {
            path: '/magic-request-email',
            name: 'magic-request',
            component: MagicLinkPre
        },
        {
            path: '/magic-link',
            name: 'magic-link',
            component: MagicLinkPost
        },
        {
            path: '/auth-link',
            name: 'auth-link',
            component: MagicLinkPost
        },
        {
            path: '/user-form',
            name: 'user-form',
            component: UserForm,
            beforeEnter: checkRights
        },
        {
            path: '/newsletters',
            name: 'NewslettersV2',
            component: NewslettersV2,
            beforeEnter: checkRights
        },
        {
            path: '/my-actions',
            name: 'my-actions',
            component: MyActions,
            beforeEnter: checkRights
        },
        {
            path: '/fetch',
            name: 'FetchExpress',
            component: FetchExpress,
            beforeEnter: checkRights
        },
        {
            path: '/fetch-and-empty',
            name: 'FetchAndEmpty',
            component: FetchAndEmpty,
            beforeEnter: checkRights
        },
        {
            path: '/add-inbox',
            name: 'add-inbox',
            component: AddInbox,
            beforeEnter: checkRights
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            beforeEnter: checkRights
        },
        {
            path: '/settings/:page',
            name: 'settings',
            component: Settings,
            beforeEnter: checkRights
        },
        {
            path: '/stats',
            name: 'stats',
            component: Stats,
            beforeEnter: checkRights
        },
        {
            path: '/instant-apps',
            component: TikTokRedirect
        },
        {
            path: '/weforest',
            name: 'weforest',
            component: WeForest,
            beforeEnter: checkRights
        },
        {
            path: '/direct-delete-account',
            name: 'direct-delete-account',
            component: DirectDeleteAccount,
            beforeEnter: needUserBefore
        },
        // PARTNERS
        {
            path: '/partner/:name',
            name: 'partner',
            component: Partner
        },
        {
            path: '/save-the-planet',
            name: 'save-the-planet',
            component: SaveThePlanet
        },
        {
            path: '/save-the-planet.html',
            redirect: '/save-the-planet'
        },

        // deeplinks
        {
            path: '/addInbox-link',
            redirect: '/add-inbox'
        },
        {
            path: '/stats-link',
            redirect: '/stats'
        },
        {
            path: '/referral-link',
            redirect: '/weforest'
        },
        {
            path: '/card-link',
            redirect: '/newsletters'
        },
        {
            path: '/stories-link',
            redirect: () => ({
                path: '/stats',
                query: {forceStories: true}
            })
        },
        {
            path: '/reconnect-link',
            redirect: '/add-inbox'
        },
        {
            path: '/panel-link',
            redirect: '/settings/panel'
        },
        {
            path: '/notif-link',
            redirect: '/settings/notifications'
        },
        // webflow
        {
            path: '/about',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/cookies-policy',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/faq',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/how-it-works',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/impressum',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/my-data',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/press',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/privacy',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/terms',
            beforeEnter: staticPagesRedirect
        },

        // others
        {
            path: '/*',
            redirect: '/'
        }
    ]
})

export default router

export function routerPushHelper(thisRouter, path) {
    thisRouter.push({path}).catch((error) => {
        if (error.message.indexOf('via a navigation guard') === -1) {
            console.error('routerPushHelper', error)
        }
    })
}

// eslint-disable-next-line complexity
function loginRules(to, from, next) {
    const provider = to.path.split('/')[2]
    // check if redirection to consent page
    const invalidGrant = to.query.invalidGrant === 'true'

    if(from.path !== '/consent-page' &&
        !invalidGrant &&
        Consent.isRequiredToConsentOnThisDevice()) {
        // Not connected, already an email, but not consented (at least on this device)
        next({path: '/consent-page', query: {provider: provider, toPath: to.path}})
    } else {
        // Not connected, no email, go to login page
        // OR
        // connected, new email (multi-accounts), go to login page
        const isSpecificProvider = Providers.isSpecificProvider(provider)
        // Current specific providers are only non-OAuth providers
        // so next route for specific is always /login/provider
        if (to.path === '/login' && isSpecificProvider) {
            next({path: `/login/${provider}`, params: {provider: provider}})
        } else {
            // loginRules is called only on /login and /login-o-auth routes
            // So no need to check if the path is /login......
            next()
        }
    }
}

function checkRights(to, from, next) {

    if (Storage.getItem('token')) {
        Store.dispatch('getUserAsync')
        Store.dispatch('firstRefreshNewsletters')
        if (Store.getters.anonymousUser && to.path !== '/user-form') {
            next({path: '/user-form'})
        }
        next()
    } else {
        Auth.disconnect()
    }
}

function staticPagesRedirect(to) {

    switch (to.path) {
        case '/privacy':
            Agreements.set.privacy()
            break
        case '/terms':
            Agreements.set.terms()
            break
    }

    window.open(`${window.location.origin}/${Storage.getItem('lang')}${to.path}.html`, '_blank', 'rel="noopener,noreferrer,nofollow"')

}

function LandingRules(to, from, next) {

    Storage.getItem('token') ? next({path: '/newsletters'}) : next()

}

function needUserBefore(to, from, next) {
    if (Storage.getItem('token')) {
        Store.dispatch('getUserSync')
            .finally(() => {
                next()
            })
    } else {
        next()
    }
}